import { render } from "./AppRouterView.vue?vue&type=template&id=7efc5178"
import script from "./AppRouterView.vue?vue&type=script&lang=js"
export * from "./AppRouterView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jissjohnson/code/Bitwissend/gnaw-now-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__